// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__db7P0 {
    background: rgba(255, 255, 255, 0.212);
    /* background: #E2F2FF; */
    border-radius: 8px;
    backdrop-filter: blur( 13px );
    box-shadow: 2px 2px 8px #00000091;
    max-width: 25rem;
}

.styles_header__6eTfD {
    align-items: center;
    background: #FFF;
    border-radius: 8px 8px 0 0;
    color: #444444;
    display: flex;
    padding: .5rem;
    font-weight: bold;
}

.styles_content__iOw5d {
    padding: 0 1rem 1rem 1rem;
}

.styles_list__hosfC li:nth-child(1) {
    border: 1px solid #00000085;
    color: #18316E;
    font-size: 1.2rem;
    font-weight: bold;
}

.styles_list__hosfC li:nth-child(1):hover {
   background: #e9e3c5;
}

.styles_list__hosfC li:nth-child(1) span {
    background: #FFAE00;
    height: 2.5rem;
    width: 2.5rem;
}

.styles_list__hosfC li:nth-child(2) span {
    background: #02D05FB2;
}

.styles_list__hosfC li:nth-child(2):hover {
    background: #a9e9d6;
 }

.styles_list__hosfC li:nth-child(3) span {
    background: #FF0004B2;
}

.styles_list__hosfC li:nth-child(3):hover {
    background: #e7ccd8;
 }

.styles_list__hosfC li:nth-child(4) span {
    background: #18316EB2;
}

.styles_list__hosfC li:nth-child(4):hover {
    background: #b2c3dc;
 }

.styles_list__hosfC li {
    align-items: center;
    background: #FFF;
    border-radius: 8px;
    box-shadow: 1px 4px 4px #C9C9C9;
    color: #7A7A7A;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    list-style-type: none;
    margin-top: .7rem;
    padding: 1rem;
}

.styles_list__hosfC li span {
    align-items: center;
    border-radius: 50%;
    box-shadow: 1px 2px 3px #00000073;
    color: #FFF;
    display: flex;
    justify-content: center;
    font-weight: bold;
    height: 2.2rem;
    width: 2.2rem;
}  

.styles_loading__7HGTv{
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    width: 100%;
  }`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/widgets/SolicitacoesWorflow/styles.module.css"],"names":[],"mappings":"AAAA;IACI,sCAAsC;IACtC,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;IAC7B,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;IAC1B,cAAc;IACd,aAAa;IACb,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,cAAc;IACd,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;GACG,mBAAmB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;CACtB;;AAED;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;CACtB;;AAED;IACI,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;CACtB;;AAED;IACI,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,+BAA+B;IAC/B,cAAc;IACd,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,iCAAiC;IACjC,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,WAAW;EACb","sourcesContent":[".container {\n    background: rgba(255, 255, 255, 0.212);\n    /* background: #E2F2FF; */\n    border-radius: 8px;\n    backdrop-filter: blur( 13px );\n    box-shadow: 2px 2px 8px #00000091;\n    max-width: 25rem;\n}\n\n.header {\n    align-items: center;\n    background: #FFF;\n    border-radius: 8px 8px 0 0;\n    color: #444444;\n    display: flex;\n    padding: .5rem;\n    font-weight: bold;\n}\n\n.content {\n    padding: 0 1rem 1rem 1rem;\n}\n\n.list li:nth-child(1) {\n    border: 1px solid #00000085;\n    color: #18316E;\n    font-size: 1.2rem;\n    font-weight: bold;\n}\n\n.list li:nth-child(1):hover {\n   background: #e9e3c5;\n}\n\n.list li:nth-child(1) span {\n    background: #FFAE00;\n    height: 2.5rem;\n    width: 2.5rem;\n}\n\n.list li:nth-child(2) span {\n    background: #02D05FB2;\n}\n\n.list li:nth-child(2):hover {\n    background: #a9e9d6;\n }\n\n.list li:nth-child(3) span {\n    background: #FF0004B2;\n}\n\n.list li:nth-child(3):hover {\n    background: #e7ccd8;\n }\n\n.list li:nth-child(4) span {\n    background: #18316EB2;\n}\n\n.list li:nth-child(4):hover {\n    background: #b2c3dc;\n }\n\n.list li {\n    align-items: center;\n    background: #FFF;\n    border-radius: 8px;\n    box-shadow: 1px 4px 4px #C9C9C9;\n    color: #7A7A7A;\n    cursor: pointer;\n    display: flex;\n    justify-content: space-between;\n    list-style-type: none;\n    margin-top: .7rem;\n    padding: 1rem;\n}\n\n.list li span {\n    align-items: center;\n    border-radius: 50%;\n    box-shadow: 1px 2px 3px #00000073;\n    color: #FFF;\n    display: flex;\n    justify-content: center;\n    font-weight: bold;\n    height: 2.2rem;\n    width: 2.2rem;\n}  \n\n.loading{\n    align-items: center;\n    display: flex;\n    height: 100%;\n    justify-content: center;\n    width: 100%;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__db7P0`,
	"header": `styles_header__6eTfD`,
	"content": `styles_content__iOw5d`,
	"list": `styles_list__hosfC`,
	"loading": `styles_loading__7HGTv`
};
export default ___CSS_LOADER_EXPORT___;
